import { BookOutlined } from "@ant-design/icons"
import { VBroker, VBrokersCreate, VBrokersList } from "."
import { EOpusPermission } from "contexts/authorization/hooks/use-opus-permissions"

export const BROKERS_ROUTES = [
  {
    path: "/brokers",
    component: VBrokersList
  },
  {
    path: "/brokers/:subpage/:id([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})?",
    component: VBrokersCreate
  },
  {
    path: "/broker/:id([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/:subpage?",
    component: VBroker
  }
]

export const BROKERS_NAVIGATION = [
  {
    title: "Brokers",
    path: "/brokers",
    childPaths: ["/broker"],
    submenu: false,
    permission: `${EOpusPermission.BrokerManagement}:true`,
    icon: <BookOutlined />,
    iconActive: <BookOutlined />
  }
]
